// key: poland translation
export default {
	'Phone must be verified': 'Telefon musi być zweryfikowany',
	'Specify phone or email': 'Podaj numer telefonu lub adres e-mail'
}
